import { lazy } from 'react';

const CircularityReceivedTransferConfig = {
	settings: {
		layout: {
			config: { footer: { display: false } }
		}
	},
	routes: [
		{
			path: '/circularity/consult/received-transfer',
			component: lazy(() => import('./ReceivedTransferContainer'))
		}
	]
};

export default CircularityReceivedTransferConfig;
